<div class="pagination-status">
  @if (from != null) {
    <span>
      Exibindo linhas:
      <span class="range"> {{ from }} - {{ to ?? '?' }} </span>
    </span>
  }
</div>
